<div class="goals-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="header-left">
            <div class="back-btn" [routerLink]="['/strategy']">
                @if(dir=='rtl'){
                <i class="pi pi-angle-right"></i>
                }@else {
                <i class="pi pi-angle-left"></i>
                }
            </div>
            <h1 class="page-title">{{ 'StrategicGoals' | navTitle | async }}</h1>
        </div>
        
        @if(user.strategy_admin){
        <button class="btn-new-goal" (click)="showGoalModal()">
            <i class="fa-solid fa-plus"></i>
            <span>{{'new_goal'|translate}}</span>
        </button>
        }
    </div>

    <!-- Toolbar: Search & View Toggle -->
    <div class="toolbar-section">
        <!-- Pillar Dropdown -->
        <div class="pillar-filter">
            <label class="filter-label">{{'pillar'|translate}}</label>
            <p-dropdown 
                styleClass="pillar-dropdown" 
                [(ngModel)]="selectedpillarId"
                (onChange)="selectPillarFn(selectedpillarId)"
                [options]="pillarOptions" 
                optionLabel="name" 
                optionValue="id" 
                placeholder="{{'select_pillar'|translate}}" />
        </div>
        
        <div class="search-wrapper">
            <i class="fa-solid fa-magnifying-glass search-icon"></i>
            <input 
                type="text" 
                class="search-input"
                [(ngModel)]="searchTerm" 
                placeholder="{{'search by goal name or code'|translate}}" />
        </div>
        
        <!-- View Toggle Buttons -->
        <div class="view-toggles">
            <button class="view-btn" 
                    [class.active]="displayType === 'cards'"
                    (click)="displayType='cards'">
                <i class="pi pi-th-large"></i>
                <span>{{'cards_view' | translate}}</span>
            </button>
            <button class="view-btn" 
                    [class.active]="displayType === 'list'"
                    (click)="displayType='list'">
                <i class="pi pi-list"></i>
                <span>{{'list_view' | translate}}</span>
            </button>
        </div>
    </div>

    <!-- Content Area -->
    @if(goals && goals.length){
        <!-- Table View -->
        @if(displayType === 'list'){
            <div class="table-container">
                <table class="goals-table-modern">
                    <thead>
                        <tr class="table-header">
                            <th class="col-name">{{'name'|translate}}</th>
                            <th class="col-pillar">{{'pillar'|translate}}</th>
                            <th class="col-indicators text-center">{{'indicators'|translate}}</th>
                            <th class="col-initiatives text-center">{{'initiatives'|translate}}</th>
                            <th class="col-actions text-center">{{'actions'|translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(goal of goals; track goal.id; let i = $index){
                        <tr class="table-row">
                            <td class="col-name">
                                <div class="goal-name-wrapper">
                                    <i class="goal-icon" [ngClass]="getGoalIcon(i)"></i>
                                    <span>{{goal.name}}</span>
                                </div>
                            </td>
                            <td class="col-pillar">
                                <span class="pillar-badge">{{goal.pillar?.name}}</span>
                            </td>
                            <td class="col-indicators text-center">
                                <button class="stat-badge stat-indicators"
                                        [routerLink]="['/goals-indicators']"
                                        [queryParams]="{ strategyId: selectedStrategyId, goalId: goal.id }">
                                    <span>{{goal.no_indicators}}</span>
                                    <i class="fa-solid fa-chart-simple"></i>
                                </button>
                            </td>
                            <td class="col-initiatives text-center">
                                <button class="stat-badge stat-initiatives"
                                        [routerLink]="['/goals-projects']"
                                        [queryParams]="{ strategyId: selectedStrategyId, goalId: goal.id }">
                                    <span>{{goal.no_projects}}</span>
                                    <i class="far fa-lightbulb"></i>
                                </button>
                            </td>
                            <td class="col-actions">
                                <div class="action-buttons">
                                    <button class="action-btn view-btn" (click)="showGoalDetails(goal)">
                                        <i class="far fa-eye"></i>
                                    </button>
                                    @if('manage' | able: 'Goal' :user){
                                    <button class="action-btn edit-btn" (click)="showUpdateGoalModal(goal.id)">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button class="action-btn delete-btn" (click)="confirmGoalDelete($event, goal.id)">
                                        <i class="far fa-trash-can"></i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        
        <!-- Cards View -->
        @if(displayType === 'cards'){
            <app-goals [isViewOnly]="false" 
                (ShowUpdateGoalModalEvent)="showUpdateGoalModal($event)"
                (onViewGoalDetails)="showGoalDetails($event)"
                [selectedStrategyId]="selectedStrategyId" 
                [goals]="goals">
            </app-goals>
        }
    }@else{
        <div class="empty-state">
            <i class="pi pi-inbox"></i>
            <p>{{"There are no goals"|translate}}</p>
        </div>
    }

    <!-- Confirm Popup -->
    <p-confirmPopup #confirmPopupRef>
        <ng-template pTemplate="headless" let-message let-test>
            <div class="border-round p-3">
                <span>{{ message.message }}</span>
                <div class="flex align-items-center gap-2 mt-3">
                    <p-button (click)="accept()" label="{{'yes'|translate}}" severity="danger"></p-button>
                    <p-button (click)="reject()" label="{{'no'|translate}}" severity="secondary"></p-button>
                </div>
            </div>
        </ng-template>
    </p-confirmPopup>

</div>

<!-- Goal Details Modal -->
@if(isViewDetailsModal && selectedViewGoal) {
<div class="modal-wrapper" style="position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; display: flex !important; align-items: center !important; justify-content: center !important; z-index: 9999 !important;">
    <div class="g-overlay" (click)="closeDetailsModal()"></div>
    <div class="g-modal details-modal" style="position: relative !important; margin: auto !important;">
        <div class="modal-header">
            <h2 class="modal-title">{{'goal'|translate}} - {{selectedViewGoal.name}}</h2>
            <button class="close-btn" (click)="closeDetailsModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal__body">
            <div class="details-grid">
                <!-- First Row: Name, Code, Weight -->
                <div class="detail-item name-item">
                    <label class="detail-label">{{'name'|translate}}</label>
                    <p class="detail-value">{{selectedViewGoal.name}}</p>
                </div>
                
                <div class="detail-item">
                    <label class="detail-label">{{'code'|translate}}</label>
                    <p class="detail-value">{{selectedViewGoal.code}}</p>
                </div>
                
                <div class="detail-item">
                    <label class="detail-label">{{'weight'|translate}}</label>
                    <p class="detail-value">{{selectedViewGoal.weight}}</p>
                </div>
                
                <!-- Description -->
                @if(selectedViewGoal.description){
                <div class="detail-item full-width">
                    <label class="detail-label">{{'description'|translate}}</label>
                    <p class="detail-value description">{{selectedViewGoal.description}}</p>
                </div>
                }
                
                <!-- Stats Row -->
                <div class="stats-row full-width">
                    <div class="stat-item-wrapper">
                        <label class="detail-label">{{'indicators'|translate}}</label>
                        <div class="stat-badge stat-indicators-badge">
                            <i class="fa-solid fa-chart-simple"></i>
                            <span>{{selectedViewGoal.no_indicators}} {{'indicators'|translate}}</span>
                        </div>
                    </div>
                    
                    <div class="stat-item-wrapper">
                        <label class="detail-label">{{'initiatives'|translate}}</label>
                        <div class="stat-badge stat-initiatives-badge">
                            <i class="fa-solid fa-lightbulb"></i>
                            <span>{{selectedViewGoal.no_projects}} {{'initiatives'|translate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}


@if(isVisibleGoalModal)
{
<div class="goal-modal-wrapper">
    <div class="goal-modal-overlay" (click)="closeGoalModal()"></div>
    <div class="goal-form-modal" role="dialog" aria-modal="true">
        <div class="goal-form-modal__header">
            <div class="goal-form-modal__title-wrap">
                <span class="goal-form-modal__icon">
                    <i class="fa-solid" [ngClass]="selectedUpdateGoalId > 0 ? 'fa-pencil' : 'fa-plus'"></i>
                </span>
                <h2 class="goal-form-modal__title">{{selectedUpdateGoalId>0?("edit goal"|translate):("add goal"|translate)}}</h2>
            </div>
            <button type="button" class="goal-form-modal__close" (click)="closeGoalModal()" aria-label="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="goal-form-modal__body">
            <form #goalForm="ngForm" (ngSubmit)="submitGoal()">
                <div class="goal-form__grid">
                    <div class="goal-form__field">
                        <label class="goal-form__label" for="name">{{"name"|translate}}</label>
                        <input class="goal-form__input" pInputText ngModel #name="ngModel" required [(ngModel)]="selectedGoal.name"
                            name="name" id="name" />
                        @if((name.invalid && name.touched)||(name.invalid && isGoalFormSubmitted)){
                        <span class="goal-form__error">{{"field_is_required"|translate}}</span>
                        }
                    </div>

                    <div class="goal-form__field">
                        <label class="goal-form__label" for="name_en">{{"name_in_english"|translate}}</label>
                        <input class="goal-form__input" pInputText ngModel #name_en="ngModel" [(ngModel)]="selectedGoal.name_en"
                            name="name_en" id="name_en" />
                    </div>

                    <div class="goal-form__field">
                        <label class="goal-form__label" for="code">{{"code"|translate}}</label>
                        <input class="goal-form__input" pInputText ngModel maxlength="6" required #code="ngModel" name="code"
                            [(ngModel)]="selectedGoal.code" id="code" />
                        @if((code.invalid && code.touched)||(code.invalid && isGoalFormSubmitted)){
                        <span class="goal-form__error">{{"field_is_required"|translate}}</span>
                        }
                    </div>

                    <div class="goal-form__field">
                        <label class="goal-form__label" for="weight">{{"weight"|translate}}</label>
                        <input class="goal-form__input" pInputText type="number" ngModel required #weight="ngModel" name="weight"
                            [(ngModel)]="selectedGoal.weight" id="weight" />
                        @if((weight.invalid && weight.touched)||(weight.invalid && isGoalFormSubmitted)){
                        <span class="goal-form__error">{{"field_is_required"|translate}}</span>
                        }
                    </div>

                    <div class="goal-form__field goal-form__field--full">
                        <label class="goal-form__label" for="pillar">{{"pillar"|translate}}</label>
                        <p-dropdown
                            id="pillar"
                            styleClass="goal-form-dropdown"
                            placeholder="{{'select_pillar'|translate}}"
                            [(ngModel)]="selectedGoal.pillar_id"
                            [options]="pillars"
                            required
                            ngModel
                            #pillar_name="ngModel"
                            name="pillar_id"
                            optionLabel="name"
                            optionValue="id" />
                        @if((pillar_name.invalid && pillar_name.touched)||(pillar_name.invalid && isGoalFormSubmitted)){
                        <span class="goal-form__error">{{"field_is_required"|translate}}</span>
                        }
                    </div>

                    <div class="goal-form__field goal-form__field--full">
                        <label class="goal-form__label" for="description">{{"description"|translate}}</label>
                        <textarea class="goal-form__textarea" pInputTextarea ngModel required #description="ngModel"
                            [(ngModel)]="selectedGoal.description" name="description"
                            id="description" rows="3"></textarea>
                        @if((description.invalid && description.touched)||(description.invalid && isGoalFormSubmitted)){
                        <span class="goal-form__error">{{"field_is_required"|translate}}</span>
                        }
                    </div>

                    <div class="goal-form__field goal-form__field--full">
                        <label class="goal-form__label" for="description_en">{{"description_in_english"|translate}}</label>
                        <textarea class="goal-form__textarea" pInputTextarea ngModel #description_en="ngModel"
                            [(ngModel)]="selectedGoal.description_en"
                            name="description_en" id="description_en" rows="3"></textarea>
                    </div>
                </div>

                <div class="goal-form__actions">
                    <p-button type="button" (onClick)="closeGoalModal()" label="{{'cancel'|translate}}"
                        [raised]="true" severity="danger" styleClass="goal-form-btn"></p-button>
                    <p-button type="ngSubmit" [disabled]="!goalForm.valid" label="{{'save'|translate}}"
                        [raised]="true" styleClass="goal-form-btn goal-form-btn--save"></p-button>
                </div>
            </form>
        </div>
    </div>
</div>
}